import axiosInstance from './axiosInstance'

export const login = async (userData) => {
  try {
    const res = await axiosInstance.post('/login/check', userData)
    return res
  } catch (error) {
    throw error
  }
}

export const PostNewsletter = async (data) => {
  try {
    const res = await axiosInstance.post('/common/professionalnewsletter', data)
    return res
  } catch (error) {
    throw error
  }
}

export const PostHelpline = async (data) => {
  try {
    const res = await axiosInstance.post('/common/helpline', data)
    return res
  } catch (error) {
    return error
  }
}

export const forgotUsernamePwd = async (data) => {
  try {
    const res = await axiosInstance.post('/login/forgotusernamepwd', data)
    return { success: true, data: res?.data }
  } catch (error) {
    return { success: false, message: error?.response?.data }
  }
}

export const resetPassword = async (data) => {
  try {
    const res = await axiosInstance.post('/login/resetpassword', data)
    return { success: true, data: res?.data }
  } catch (error) {
    return { success: false, message: error?.response?.data }
  }
}

export const resetValidateToken = async (data) => {
  try {
    const res = await axiosInstance.post('/login/validateresetpasswordtoken', data)
    return { success: true, data: res?.data }
  } catch (error) {
    return { success: false, message: error?.response?.data }
  }
}

export const checkForEmail = async (body) => {
  let res = ''
  try {
    let url = `/login/checkforemail`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const checkForUserName = async (body) => {
  let res = ''
  try {
    let url = `/login/checkforusername`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const postRegisterClient = async (body) => {
  let res = ''
  try {
    let url = `/login/registerclient`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const postRegisterProfessional = async (body) => {
  let res = ''
  try {
    let url = `/login/registerprofessional`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}

export const postUnsubscribeReminder = async (body) => {
  let res = ''
  try {
    let url = `/common/UnsubscribeRemainder`
    res = await axiosInstance.post(url, body)
    return res.data
  } catch (e) {
    return e.response ? e.response.data : e
  }
}
